module.exports = __webpack_public_path__ + "static/media/bg23.9790984e.jpg";